// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'investment.page.title': 'Investments',
    'investment.page.search_results': 'Search Results',
    'investment.page.create.title': 'Create New Investment',
    'investment.page.search.title': 'Find Investments',
    'investment.page.edit.title': 'Edit Investment',
    'investment.page.view.title': 'View Investment',
    'investment.page.all': 'All',

    'investment.button.cancel': 'Cancel',
    'investment.button.select': 'Select',
    'investment.button.find': 'Find Investments',
    'investment.button.search': 'Apply',
    'investment.button.create': 'Create Investment',
    'investment.button.new': 'New Investment',
    'investment.button.save': 'Save Changes',
    'investment.button.draft': 'Save draft',
    'investment.button.edit': 'Edit',
    'investment.button.restore': 'Restore',
    'investment.button.reset': 'Reset',
    'investment.button.rollback': 'Rollback Investment',
    'investment.button.void': 'Void Investment',
    'investment.button.cancel_draft': 'Cancel Draft',
    'investment.button.record_sale': 'Record Sale',

    'investment.placeholder.search': 'Search investments',

    'investment.link.create_first_investment': 'Click here to create your first investment',
    'investment.link.investments': ' Return to Investments',
    'investment.link.returns': 'Investment Returns',
    'investment.link.sales': 'Investment Sales',
    'investment.link.valuations': 'Investment Valuations',
    'investment.link.retry': 'Click here to retry',

    'investment.checkbox.all': 'Check All',
    'investment.checkbox.actions_label': 'with selected',

    'investment.label.investment_type_name': 'Investment Type',
    'investment.label.financial_institution_name': 'Invested With',
    'investment.label.instrument_name': 'Instrument Name',
    'investment.label.purchase_date': 'Purchase Date',
    'investment.label.maturity_date': 'Maturity Date',
    'investment.label.units_purchased': 'Units Purchased',
    'investment.label.units_purchased_units': 'Description',
    'investment.label.currency_name': 'Currency',
    'investment.label.currency_initial_value_in_cents': 'Initial Value',
    'investment.label.currency_current_value_in_cents': 'Current Value',
    'investment.label.notes': 'Notes',
    'investment.label.bank_general_ledger_account_name': 'Paid From Bank Account',
    'investment.label.investment_general_ledger_account_name': 'Investment Account',
    'investment.label.void_reason': 'Reason for voiding investment',
    'investment.label.rollback_reason': 'Reason for rolling back investment',

    'investment.sort.field_label': 'Field',
    'investment.sort.direction_label': 'Direction',
    'investment.sort.direction_ascending': 'Ascending',
    'investment.sort.direction_descending': 'Descending',

    'investment.modal.title.investment_restore': 'Restore Investment',
    'investment.modal.title.investment_rollback': 'Rollback Investment',
    'investment.modal.title.investment_void': 'Void Investment',

    'investment.modal.message.investment_restore': 'Are you sure that you want to restore this investment? | Are you sure that you want to restore these investments?',
    'investment.modal.message.investment_rollback': 'Are you sure that you want to rollback this investment?',
    'investment.modal.message.investment_void': 'Are you sure that you want to void this investment?',

    'investment.success.message.investment_created': 'Your investment has been created',
    'investment.success.message.investment_updated': 'Your investment has been updated',
    'investment.success.message.investment_restored': 'Your investment has been restored | All selected investments were restored',
    'investment.success.message.investment_cancelled': 'Your draft investment has been cancelled.',
    'investment.success.message.investment_voided': 'Your investment has been voided.',
    'investment.success.message.investment_rolled_back': 'Your investment has been rolled back.',

    'investment.error.message.investment_deleted': 'This investment was already permanently deleted | These investments were already permanently deleted',
    'investment.error.message.investment_restored': 'This investment was already restored | These investments were already restored',
    'investment.error.message.error_loading_page': 'Sorry, there was an error loading investment.| Sorry, there was an error loading investments.',
};
